import React from 'react'
import { parse } from 'qs'
import { useLocation } from 'react-router-dom'
import { sortBy } from 'lib/helpers/lists'

import { useQuery } from '@apollo/client'
import query from './query.graphql'

// lib

const withQuery = WrappedComponent => {
  return props => {
    // get optional date query
    const {
      onQueryError // via withQueryResults
    } = props
    const location = useLocation()
    const search = parse(location.search.replace(/^\?/, ''))
    const { date = null } = search

    const { loading, data, refetch } = useQuery(query, {
      onError: onQueryError,
      variables: { date }
    })

    const { roomMeetings = [] } = data || {}
    const sortedMeetings = [...roomMeetings].sort(sortBy('startsAt'))

    return (
      <WrappedComponent
        loading={loading}
        roomMeetings={sortedMeetings}
        date={date}
        refetch={refetch}
        {...props}
      />
    )
  }
}

export default withQuery
